



























































import { Component, Inject } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";

import { current } from "@szgc/plt-core-v2";
import MagicValidator from "../../../magic/MagicValidator.vue";
import { default as selectComponent } from "../../../components/UserSelectComponentNew/index.vue";
import { default as mobileUserSelect } from "../../../components/MobileUserComponent/index.vue";

@Component({
  name: "UserSelectSingleWidget",
  components: {
    selectComponent,
    mobileUserSelect,
    MagicValidator
  }
})
export default class UserSelectSingleWidget
  extends EventWidgetComponent
  implements App.PuttedWidgetComponent, App.LinkedWidgetComponent, App.PutAbleWidgetComponent
{
  @Inject({ from: "client", default: "web" })
  private client!: "web" | "mobile";

  private show: boolean = false;
  private list: any[] = [];
  private orgId: any = "";

  putModel: any = {};
  params: App.LinkedWidgetComponentParam[] = [];

  initText() {
    if (this.status === "mine") {
      if (this.value) {
        const ext = Array.isArray(this.widget.ext) ? this.widget.ext : [this.widget.ext];
        this.widget.text = ext.map((i: any) => i.realName).join("、");
        return false;
      }
      const { field } = this.defaultValue;
      const { userId, username, ...rest } = current;
      [userId, username];
      if (["realName", "userId"].includes(field)) {
        this.widget.text = current.realName;
        this.value = current.userId;
      }
      if (["leaderName", "leaderId"].includes(field)) {
        this.widget.text = (current as any).leaderName;
        this.value = current.leaderId;
      }

      this.$nextTick(() => {
        this.putModel = {
          userId: this.value,
          userName: this.widget.text,
          ...(field ? rest : {})
        };
        this.handleEvent(this.value);
      });
      return false;
    }
    if (this.value) {
      const ext = Array.isArray(this.widget.ext) ? this.widget.ext : [this.widget.ext];
      this.widget.text = ext.map((i: any) => i.realName).join("、");
    }
  }

  // @Watch("widget")
  // widgetWatcher(n: any) {
  //   if (this.value) {
  //     const ext = Array.isArray(this.widget.ext)
  //       ? this.widget.ext
  //       : [this.widget.ext];
  //     this.widget.text = ext.map((i: any) => i.realName).join("、");
  //   }
  // }

  reset() {
    this.widget.text = "";
    this.value = "";

    this.putModel = { userId: this.value, userName: this.widget.text };
    this.handleEvent(this.value);
  }

  refresh(option: App.LinkEventOption) {
    this.params = [
      {
        key: option.property,
        value: option.value
      }
    ];
    this.orgId = option.value;

    this.reset();

    // this.getFormData();
  }

  setValue(value: string) {
    // this.reset();

    if (!/[0-9]+/.test(value)) {
      this.value = "";
      this.widget.text = "";
    } else {
      this.value = value.split(",")[0];
      this.widget.text = value.split(",")[1];
    }

    this.putModel = { userId: this.value, userName: this.widget.text };
    this.handleEvent(this.value);
  }

  confirm(data: any) {
    // if (!data.source.length) return false;
    this.widget.ext = data.source;
    const item = data.source[0];
    this.putModel = item;
    this.handleEvent(this.value);
  }

  created() {
    this.initText();
  }
  async showHandler() {
    if (!this.widget.readonly) {
      // await this.getFormData();
      this.show = true;
    }
  }
}
